<template>
  <div class="timeline-container">
    <div class="timeline">
      <div class="timeline__history-line"></div>

      <div class="timeline__epochs">
        <EpochVRAK
            v-for="epoch in epochs"
            :key="epoch.id"
            :epoch="epoch"
            :translations="translations"
            @toggle-epoch="onToggleEpoch"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import EpochVRAK from "../epoch/EpochVRAK.vue";

import { useTimelineData } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useTimelineData";
import { useEpochToggle } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useEpochToggle";
import { useTimelineEffects } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useTimelineEffects";

const { epochs, translations } = useTimelineData();

const { onToggleEpoch } = useEpochToggle(translations);

useTimelineEffects();
</script>
